module.exports = __webpack_public_path__ + "img/thumbnail_EuropeanFallowDeer_j_normal.6bb859f5.png";